module.exports = __webpack_public_path__ + "media/images/teams/ROMA-4da2fc4e7b40b0127efc5a1a96b04cc3.png";